export default {
  title: 'NAVIGATE 2023-Home-H3C',
  meta: [
    {
      name: 'keywords',
      content: 'Navigate2023, Navigate, H3C, digitalization,  digital economy, AI, AIGC, ICT'
    },
    {
      name: 'description',
      content:
        'The H3C 2023 Navigate Summit, themed "Dedication For A Smarter Future", will be held in Hangzhou on June 9. Participants will discuss new challenges and coping strategies faced by the ICT industry in the AIGC era and share innovative breakthroughs and successful cases across industries during the digital transformation. '
    }
  ]
}
